import { Link } from "react-router-dom";

import { SwiftLogo } from "@/components/brand/swift-logo";
import { SignOutButton } from "@/components/sign-out-button";
import { ThemeToggle } from "@/components/theme/theme-toggle";

type SiteHeaderProps = {
  variant: "app" | "admin";
  userEmail?: string | null;
};

export function SiteHeader({ variant, userEmail }: SiteHeaderProps) {
  const homeHref = variant === "admin" ? "/admin" : "/dashboard";
  const isAdmin = variant === "admin";

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-md supports-[backdrop-filter]:bg-background/70">
      <div
        className={
          variant === "app"
            ? "flex h-14 w-full items-center justify-between gap-3 px-4 sm:px-6"
            : "mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-6"
        }
      >
        <Link
          to={homeHref}
          className="brand-focus-ring flex min-w-0 items-center gap-2.5 rounded-md"
        >
          <SwiftLogo priority className="h-[22px] w-auto sm:h-6 dark:invert" />
          {isAdmin ? (
            <span className="rounded-md bg-foreground/[0.06] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-foreground/70">
              Admin
            </span>
          ) : null}
        </Link>
        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          {isAdmin && userEmail ? (
            <span className="hidden max-w-[220px] truncate text-[12.5px] text-muted-foreground sm:inline md:max-w-[300px]">
              {userEmail}
            </span>
          ) : null}
          <ThemeToggle className="hidden sm:inline-flex" />
          {isAdmin ? <SignOutButton /> : null}
        </div>
      </div>
    </header>
  );
}
